import { Button, DialogOverlay, DialogOverlayFooter, DialogOverlayActions, useStatusOverlay } from '@fs/zion-ui'
import React from 'react'
import { NoticeLoading } from '@fs/zion-icon'
import { Trans } from 'react-i18next/icu.macro'
import transl from './GroupDataHeader.transl'
import { useSubmitCaiReview } from '../../hooks'

export default function FinishRecordMetadataReviewOverlay({ finishRecordMetadataReviewOverlay }) {
  const showStatusOverlay = useStatusOverlay()
  const [resolvingCAIReview, setResolvingCAIReview] = React.useState()

  const { submitCaiReview } = useSubmitCaiReview({
    onError: () => {
      showStatusOverlay({
        message: transl.errorMessage(),
        type: 'error',
        dismissable: true,
      })
      finishRecordMetadataReviewOverlay.close()
    },
    setLoading: setResolvingCAIReview,
  })

  return (
    <DialogOverlay {...finishRecordMetadataReviewOverlay} title={transl.finishRecordMetadataReviewTitle()}>
      <Trans
        i18nKey="GroupDataHeader.finishRecordMetadataReviewDialogBody"
        defaults="You can go back to make changes, or click <strong>Yes, Submit Review</strong> to complete the Record Metadata Review for this image group. The records will be published and made searchable for users."
      />

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button
            disabled={resolvingCAIReview}
            onClick={() => finishRecordMetadataReviewOverlay.close()}
            emphasis="low"
          >
            {transl.finishRecordMetadataReviewBackButton()}
          </Button>
          <Button
            data-testid="finish-record-metadata-review-button"
            disabled={resolvingCAIReview}
            Icon={resolvingCAIReview && NoticeLoading}
            onClick={submitCaiReview}
            emphasis="high"
          >
            {transl.finishReviewButton()}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
